import { useEffect, useMemo, useState } from "react";
import { readReportWorkspace, subscribeReportWorkspace } from "./reportStore";

export function useReportWorkspace(userId, areaId) {
  const scope = useMemo(
    () => ({
      userId: userId == null ? "" : String(userId),
      areaId: areaId == null ? "" : String(areaId),
    }),
    [userId, areaId]
  );

  const [workspace, setWorkspace] = useState(() => readReportWorkspace(scope.userId, scope.areaId));

  useEffect(() => {
    const refresh = () => setWorkspace(readReportWorkspace(scope.userId, scope.areaId));
    refresh();
    return subscribeReportWorkspace(refresh);
  }, [scope.userId, scope.areaId]);

  return workspace;
}

